<template>
    <table class="c-products-table">
        <tbody v-for="(product, index) in products">
        <tr>
            <td>
                <img v-if="product.Thumbnail" class="u-no-max-width" :src="product.Thumbnail.replace('[WIDTH]', 160).replace('[HEIGHT]', 100)" width="80" height="50" :alt="product.Title">
                <img v-else src="@/assets/images/no_image.png" width="80" alt="">
            </td>
            <td>
                <span class="u-font-weight-medium u-font-small">{{ product.Title }}</span>
                <span v-if="product.Model" class="u-font-extra-small"><br>{{ product.Model }}</span>
                <span v-if="product.EAN" class="u-font-extra-small"><br>{{ product.EAN }}</span>
            </td>
            <td>
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.size.label') }}</span>
                <span v-if="product.Size"><br>{{ product.Size }}</span>
            </td>
            <td>
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.color.label') }}</span>
                <span v-if="product.Color">
                    <br>
                    <div v-if="product.ColorHex" class="c-product-color-element" v-bind:style="{ backgroundColor: product.ColorHex}"></div>
                    <span style="position: relative; top: -8px; font-size: 13px;">{{ product.Color }}</span>
                </span>
            </td>
            <td v-if="!isMarketing">
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.unit_price.label') }}</span>
                <span v-if="product.UnitPrice" class="u-text-no-wrap"><br>{{ product.UnitPrice | currency(customerCurrencySymbol) }}</span>
                <span v-if="product.UnitPriceSuffix" class="u-font-extra-tiny u-color-muted u-line-height-1 u-block">{{ product.UnitPriceSuffix }}</span>
            </td>
            <td>
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.quantity.label') }}</span>
                <span v-if="product.Quantity" class="u-text-no-wrap"><br>{{ product.Quantity }}</span>
                <span v-if="product.QuantityRemainToDeliver > 0" class="u-font-extra-tiny u-color-muted u-line-height-1 u-block">{{ product.QuantityRemainToDeliver }} {{ $t('customer.account.backorders.in_backorder') }}</span>
                <span v-if="product.QuantityShipped > 0" class="u-font-extra-tiny u-color-muted u-line-height-1 u-block">{{ product.QuantityShipped }} {{ $t('customer.account.backorders.delivered') }}</span>
                <span v-if="product.QuantityCanceled > 0" class="u-font-extra-tiny u-color-muted u-line-height-1 u-block">{{ product.QuantityCanceled }} {{ $t('customer.account.backorders.cancelled') }}</span>
            </td>
            <td v-if="!isMarketing">
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.total_price.label') }}</span>
                <span v-if="product.TotalPrice" class="u-text-no-wrap"><br>{{ product.TotalPrice | currency(customerCurrencySymbol) }}</span>
            </td>
            <td v-if="!isMarketing && showReOrder && canReOrder(product)">
                <button class="c-button c-button--tiny c-button--alpha" @click="shoppingCartButtonClicked(product.ProductVariantId)">
                    <svg version="1.1" viewBox="0 0 24 24" class="svg-icon svg-fill" style="width: 24px; height: 24px;"><path pid="0" fill-rule="evenodd" d="M15.75 21.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0zm-6 2.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zM20.47 7.5l-2.078 6.75H9.35L7.218 7.5H20.47zM1.5 3h1.15l4.17 13.203a1.5 1.5 0 0 0 1.43 1.047H19.5a1.5 1.5 0 0 0 1.433-1.057l3-9.75A1.5 1.5 0 0 0 22.5 4.5H6.27L5.18 1.047A1.5 1.5 0 0 0 3.75 0H1.5a1.5 1.5 0 0 0 0 3z"></path></svg>
                </button>
            </td>
        </tr>
        <tr v-if="(product.OrderDate || product.OrderNumber || product.ExpectedDeliveryDate) && product.QuantityRemainToDeliver > 0" class="c-products-table__bar">
            <td colspan="2" class="u-font-extra-tiny u-bg-whitesmoke">
                <span v-if="product.OrderDate">
                    <span class="u-font-weight-medium">
                        {{ $t('customer.account.backorders.order_date.label') }}:
                    </span>
                    {{ product.OrderDate | moment('DD-MM-YYYY') }}
                </span>
            </td>
            <td colspan="6" class="u-font-extra-tiny u-bg-whitesmoke">
                <span v-if="product.OrderNumber" class="u-color-accent-base">
                    <span class="u-font-weight-medium ">
                        {{ $t('customer.account.backorders.order_number.label') }}:
                    </span>
                    <template v-if="product.OrderId">
                        <router-link :to="{ name:'CustomerAccountHistoryDetail', params: { id: product.OrderId} }">
                            {{ product.OrderNumber }}
                        </router-link>
                    </template>
                    <template v-else>
                        {{ product.OrderNumber }}
                    </template>
                </span>
                <span v-if="product.ExpectedDeliveryDate" class="u-pull-right">
                    <span class="u-font-weight-medium">
                        {{ $t('customer.account.backorders.order_expected_delivery_date.label') }}:
                    </span>
                    {{ product.ExpectedDeliveryDate | moment('DD-MM-YYYY') }}
                </span>

            </td>
        </tr>

        <tr v-if="index !== products.length - 1">
            <td colspan="8">
                <hr class="c-products-table__hr">
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: {
            products: Array,
            showReOrder: { type: Boolean, default: false }
        },
        computed: {
            isMarketing() {
                return this.$store.getters.isMarketing;
            },
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods: { 
            shoppingCartButtonClicked(productId){
                this.$emit('shoppingCartButtonClicked', productId);
            },
            canReOrder(product) {
                return product && product.Status !== 'PRE' && product.Status !== 'PRE2' && product.IsWebshopEnabled && !product.IsDisabled;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-products-table {
        @include rfs(16);

        th,
        td {
            vertical-align: top;
            padding: 12px;
        }

        &__hr {
            margin: 0 -15px;
            border: none;
            border-bottom: dashed 1px rgba(#9B9B9B, .5);

            .c-products-table__bar + tr &{
                margin-top: 15px;
            }
        }

    }

    .c-product-color-element {
        width: 30px;
        height: 30px;
        margin-right: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/shop/ProductsTable.vue